<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch} from 'vue';
import { useRouter } from 'vue-router';

import NavBar from './components/NavBar.vue';
import Landing from './components/Landing.vue';
import News from './components/News.vue';
import Guidelines from './components/Guidelines.vue';
import Connect from './components/Connect.vue';
import ScienceMedicine from './components/ScienceMedicine.vue';
import ArtsHumanities from './components/ArtsHumanities.vue';
import HideMobile from './components/HideMobile.vue';

// Variable Declarations
const router = useRouter();
const currentpath = ref("home");
const isMobile = ref(false);


// Function Declarations
onMounted(() => {
  router.push('/');

});

watch(router.currentRoute, () => {
  currentpath.value = router.currentRoute.value.name as string;
});

</script>

<template>
  <div class="min-h-screen bg-white">
    <div class="sticky top-0 z-50 bg-white border-b border-[#012331]/10 shadow-sm">
      <div class="w-full flex items-center justify-center py-2 sm:py-4 border-b-2">
        <NavBar />
      </div>
    </div>
    <main class="w-full">
      <div v-if="currentpath == 'home'" class="flex justify-center">
        <Landing />
      </div>
      <div v-else-if="currentpath == 'news'">
        <News />
      </div>
      <div v-else-if="currentpath == 'sciencemedicine'">
        <ScienceMedicine />
      </div>
      <div v-else-if="currentpath == 'artshumanities'">
        <ArtsHumanities />
      </div>
      <div v-else-if="currentpath == 'guidelines'">
        <Guidelines />
      </div>
      <div v-else-if="currentpath == 'connect'" class="flex justify-center">
        <Connect />
      </div>
    </main>
  
    <div class="fixed bottom-4 right-4 z-40 pointer-events-none">
      <div class="text-[#012331]/30 text-sm font-satoshi select-none">
        Faheem Mazhar @ 2024
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './tailwind.css';
</style>
